module.exports = vendor_b5589fc489b20d870461;